import React from "react";
import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Marie D.",
    role: "Office Manager — Cabinet juridique",
    city: "Paris 8e",
    content:
      "Équipe très professionnelle, discrète et toujours ponctuelle. Nos bureaux sont impeccables chaque matin. Le suivi qualité fait vraiment la différence.",
    rating: 5,
  },
  {
    name: "Julien R.",
    role: "Gérant — Restaurant",
    city: "Neuilly-sur-Seine",
    content:
      "Réactivité sans faille et produits parfaitement adaptés à nos cuisines. Un partenaire fiable qui comprend nos contraintes de timing. Je recommande sans hésiter.",
    rating: 5,
  },
  {
    name: "Sophie L.",
    role: "Syndic — Copropriété résidentielle",
    city: "Boulogne-Billancourt",
    content:
      "Prestations constantes depuis plus de deux ans. Communication fluide et tarifs transparents. Les résidents ne tarissent pas d'éloges sur les parties communes.",
    rating: 5,
  },
  {
    name: "Karim B.",
    role: "Directeur — Entrepôt logistique",
    city: "Gennevilliers",
    content:
      "Nettoyage industriel nickel, matériel adapté et équipe autonome. Intervention rapide pour un après-chantier complexe. Excellent rapport qualité/prix.",
    rating: 5,
  },
];

export default function Testimonials() {
  return (
    <section id="temoignages" className="relative py-24 md:py-32 bg-white" data-testid="testimonials-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="mb-16 max-w-3xl">
          <div className="text-xs uppercase tracking-[0.3em] text-[#2E9E6E] font-medium mb-4">
            — Ils nous font confiance
          </div>
          <h2 className="font-display font-semibold text-4xl md:text-5xl lg:text-6xl text-[#0F2B5B] leading-[1.02] tracking-tight">
            Des professionnels satisfaits, partout en Île-de-France.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-5 md:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="relative bg-[#F8FAFC] border border-slate-200 p-8 md:p-10 hover:border-[#2E9E6E] transition-colors"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="absolute top-6 right-6 w-8 h-8 text-[#2E9E6E]/30" strokeWidth={1.5} />
              <div className="flex gap-1 mb-6">
                {Array.from({ length: t.rating }).map((_, idx) => (
                  <Star key={idx} className="w-4 h-4 fill-[#2E9E6E] text-[#2E9E6E]" />
                ))}
              </div>
              <blockquote className="text-lg md:text-xl text-[#0F172A] leading-relaxed font-medium">
                « {t.content} »
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-slate-200">
                <div className="font-display font-semibold text-[#0F2B5B]">{t.name}</div>
                <div className="text-sm text-slate-600 mt-1">
                  {t.role} · <span className="text-[#2E9E6E]">{t.city}</span>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
